<template>
  <v-container>
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col cols="12" lg="12" md="12" sm="12" xl="12">
          <v-autocomplete
            :items="listBanks"
            item-text="label"
            label="Banco"
            :rules="textRules"
            v-model="component.bank.bank"
            :readonly="component.justVisible"
            outlined
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="6" xl="6">
          <v-text-field
            v-model="component.bank.count"
            :readonly="component.justVisible"
            :rules="textRules"
            label="Conta"
            outlined
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="6" xl="6">
          <v-text-field
            v-model="component.bank.agency"
            :readonly="component.justVisible"
            :rules="textRules"
            label="Agência"
            outlined
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="12" md="12" sm="12" xl="12">
          <v-text-field
            v-model="component.bank.manager"
            :readonly="component.justVisible"
            label="Gerente"
            outlined
          >
          </v-text-field>
        </v-col>
      </v-row>
      
    </v-form>
  </v-container>
</template>

<script>
import { listBanks } from "./listBank";
export default {
  props: {
    component: Object(),
  },
  data: () => ({
    valid: Boolean(),
    listBanks,
    textRules: [(v) => !!v || "Campo obrigatório!"],
  }),
  methods: {
    reset() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>

<style>
</style>